export function faviconChange(href: string) {
    const faviconLink = document.getElementById('favicon')
    if (faviconLink instanceof HTMLLinkElement) {
        faviconLink.href = href
    }
}
